<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab key="configVariables">Config Variables</v-tab>
      <v-tab key="projectProperties">Project properties</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="configVariables">
        <config-variables />
      </v-tab-item>
      <v-tab-item key="projectProperties">
        <project-properties />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ProjectProperties from "./projectProperties/Index";
import ConfigVariables from "./ConfigVariables";

export default {
  name: "ProjectConfig",
  components: { ProjectProperties, ConfigVariables },
  data() {
    return {
      tab: 0
    };
  }
};
</script>
